import React from 'react';

export const DateAnswerField = ({
	fieldValue = null,
	onAnswerChange
}) => {
	
	return (
		<div>
			<input type="date"
			className='form-control w-auto'
			value={fieldValue}
			onChange={(e) => onAnswerChange(e.target.value)}/>
		</div>
	);
};

export default DateAnswerField;
